<div role="contentinfo" class="footer text-white text-center">
  <div
    class="footer-text bg-primary text-black d-flex align-items-center justify-content-center w-100"
    [ngClass]="{ 'bg-surface-kid border-0': isKid }"
  >
    <div class="footer-content">
      <img
        alt=""
        class="footer-logo mb-2"
        [src]="(isKid ? 'logo/logo-kid.svg' : 'logo/logo.svg') | contentAssetImage"
        draggable="false"
      />
      <p class="text-white mb-0 font-size-14">{{ 'footer.copyright' | translate }}</p>
      <p class="text-white m-0 font-size-14">{{ 'footer.sub.description' | translate }}</p>
    </div>
  </div>
</div>
